module.exports = __webpack_public_path__ + "img/strategy_ub.4508c46d.svg";